import { Grid } from "@mui/material";
import React from "react";
import { Button, Card, Form, GoBack, Title } from "../../../../components";
import ControlledAutocomplete from "../../../../components/inputs/ControlledAutocomplete";
import {
  ControlledRadioGroup,
  ControlledTextField,
  CpfCnpjTextField,
  CurrencyTextField,
  DateTextField,
  Radio,
} from "../../../../components/inputs";
import Stepper from "../Stepper";
import UpperCaseTextField from "../../../../components/inputs/UpperCaseTextField";

const DadosOutrasInformacoesDefaultForm = ({
  perfisRenda,
  fluxo,
  events,
  formProps,
  handleSubmit,
  submitting,
  handleGoTo2,
  profissoes,
}) => {
  return (
    <Grid item container justifyContent={"center"} mb={4}>
      <Grid item container spacing={3} direction={"column"} maxWidth={704}>
        <GoBack
          handleClick={handleGoTo2}
          text={"Preencha as informações do cliente"}
        />
        <Grid item container alignItems={"center"}>
          <Grid item flex={1}>
            <Stepper current={2} events={events} fluxo={fluxo} />
          </Grid>
        </Grid>
        <Grid item container>
          <Grid item width={1}>
            <Card>
              <Form onSubmit={handleSubmit}>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <Title as={"h5"}>Outras Informações</Title>
                  </Grid>
                  <Grid item xs={12}>
                    <ControlledRadioGroup
                      label="Pessoa Politicamente Exposta?"
                      name={"ppe"}
                      tooltip={
                        "Pessoas Politicamente Expostas, também conhecidas como PEPs, são indivíduos que passam por um monitoramento especial das suas movimentações financeiras e fiscais, com objetivo de prevenir a corrupção e crimes como lavagem de dinheiro."
                      }
                      row
                      formProps={formProps}
                    >
                      <Radio value={true} label={"Sim"} />
                      <Radio value={false} label={"Não"} />
                    </ControlledRadioGroup>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <ControlledRadioGroup
                      label="US Person?"
                      name={"usPerson"}
                      tooltip={
                        "Caracterizam-se como US PERSON pessoas que possuem cidadania norte-americana, nascidas nos EUA ou com pais norte-americanos. Presença física nos Estados Unidos para fins tributários por pelo menos 31 dias durante o ano corrente ou 183 dias nos últimos 3 anos; E se a pessoa tem responsabilidade de pagar imposto nos EUA."
                      }
                      row
                      formProps={formProps}
                    >
                      <Radio value={true} label={"Sim"} />
                      <Radio value={false} label={"Não"} />
                    </ControlledRadioGroup>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <ControlledRadioGroup
                      label="Residente Fiscal no Brasil?"
                      name={"residenciaFiscalBrasil"}
                      tooltip={
                        "Um residente fiscal é alguém que possui domicílio no Brasil ou permanece no país por mais de 183 dias, consecutivos ou não, em um ano-calendário. Isso inclui tanto brasileiros quanto estrangeiros que atendam a esses critérios."
                      }
                      row
                      formProps={formProps}
                    >
                      <Radio value={true} label={"Sim"} />
                      <Radio value={false} label={"Não"} />
                    </ControlledRadioGroup>
                  </Grid>
                  <Grid item xs={12}>
                    <Title as={"h5"}>Dados Profissionais</Title>
                  </Grid>
                  <Grid item xs={12} md={5}>
                    <ControlledTextField
                      label="Renda Bruta Total Mensal"
                      name={"renda"}
                      formProps={formProps}
                      InputProps={{
                        inputComponent: CurrencyTextField,
                      }}
                      inputProps={{
                        allowNegative: false,
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} md={5}>
                    <ControlledAutocomplete
                      label="Perfil de Renda"
                      name={"perfilRenda"}
                      domain={perfisRenda}
                      idField={"id"}
                      labelField={"descricao"}
                      formProps={formProps}
                      autocompleteProps={{
                        clearText: "Limpar",
                        loadingText: "Carregando opções",
                        noOptionsText: "Nenhuma opção disponível",
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <ControlledTextField
                      label="Patrimônio"
                      name={"patrimonio"}
                      formProps={formProps}
                      InputProps={{
                        inputComponent: CurrencyTextField,
                      }}
                      inputProps={{
                        allowNegative: false,
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} md={8}>
                    <ControlledAutocomplete
                      label="Profissão"
                      name={"dadosProfissionais.profissao"}
                      domain={profissoes}
                      idField={"id"}
                      labelField={"descricao"}
                      formProps={formProps}
                      autocompleteProps={{
                        clearText: "Limpar",
                        loadingText: "Carregando opções",
                        noOptionsText: "Nenhuma opção disponível",
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} md={7}>
                    <ControlledTextField
                      label="Cargo"
                      name={"dadosProfissionais.cargo"}
                      inputProps={{ maxLength: 100 }}
                      formProps={formProps}
                      InputProps={{
                        inputComponent: UpperCaseTextField,
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} md={8}>
                    <ControlledTextField
                      label="Nome da Empresa"
                      name={"dadosProfissionais.nomeEmpresa"}
                      inputProps={{ maxLength: 100 }}
                      formProps={formProps}
                      InputProps={{
                        inputComponent: UpperCaseTextField,
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <ControlledTextField
                      label={"Data de Início"}
                      name={"dadosProfissionais.dataAdmissao"}
                      formProps={formProps}
                      InputProps={{
                        inputComponent: DateTextField,
                      }}
                    />
                  </Grid>
                  <Grid item container justifyContent={"center"} mt={1}>
                    <Grid item xs={12} md={4}>
                      <Button type={"submit"} fullWidth loading={submitting}>
                        CONTINUAR
                      </Button>
                    </Grid>
                  </Grid>
                </Grid>
              </Form>
            </Card>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default DadosOutrasInformacoesDefaultForm;
